import { useState } from "react";
import { toast } from "sonner";
import { Check, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import api, { formatApiErrorDetail } from "@/lib/api";
import { buildPayload } from "@/components/UsedVanDialog";

export const QuickUsedPrice = ({ expo, t, onSaved }) => {
  const cur = Number(expo.used?.price_ttc) || 0;
  const [val, setVal] = useState(cur > 0 ? String(cur) : "");
  const [busy, setBusy] = useState(false);
  const price = Number(String(val).replace(",", ".").replace(/\s/g, ""));
  const changed = price > 0 && price !== cur;
  const save = async () => {
    if (!changed) return;
    setBusy(true);
    try {
      const u = { ...expo.used, price_ttc: price, location: expo.used?.location || expo.name, phone: expo.used?.phone ?? expo.poster?.phone ?? "", photos: expo.used?.photos || [] };
      await api.put(`/expos/${expo.id}`, buildPayload(u, expo, expo.reseller_ids));
      toast.success(t("Prix de vente enregistré"));
      onSaved?.();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-2 mt-2" data-testid={`quick-price-${expo.id}`}>
      <span className="text-xs font-medium whitespace-nowrap">{t("Prix de vente TTC")}</span>
      <Input inputMode="decimal" value={val} onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") save(); }}
        placeholder={t("À saisir")} className="h-8 font-mono" data-testid={`quick-price-input-${expo.id}`} />
      <Button size="sm" className="h-8 gap-1" disabled={!changed || busy} onClick={save} data-testid={`quick-price-save-${expo.id}`}>
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Check className="w-3.5 h-3.5" />} {t("OK")}
      </Button>
    </div>
  );
};
